export default __webpack_public_path__ + "static/chaudiere-a-bois-6ffd02313dd53d5bee2a7694e3632879.jpg";